///////////////////////////////////////////////////////////////////////////////////////////////////
//
//  Namespaces
//
///////////////////////////////////////////////////////////////////////////////////////////////////
abcsetup.new_vendor = abcsetup.new_vendor || {};
abcsetup.new_vendor.credit_evaluation_delegate = abcsetup.new_vendor.credit_evaluation_delegate || {};


///////////////////////////////////////////////////////////////////////////////////////////////////
//
//  Methods
//
///////////////////////////////////////////////////////////////////////////////////////////////////
abcsetup.new_vendor.credit_evaluation_delegate = {
    init: function () {
        abcsetup.setTitle('SAP Supplier Credit Evaluation Delegation Task');

        $(document).on('click', '#cancel-delegation-task-btn', function(e) {
            abcsetup.alerts.confirm("Cancel Delegation?", "Are you sure you want to cancel and reject this delegation task back to the Supplier? They will be notified that you were unable to complete the task.", function(resp) {
                if (resp) {
                    $('#cancel-delegation-task-form').submit();
                }
            });
        });
    },
}
